export default __webpack_public_path__ + "static/media/binni.33edb668.jpg";